(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rudie-shipping-returns"] && !Shopify.designMode) return;
  try {
    (() => {
  const update = () => document.querySelectorAll('[data-dispatch-zone]').forEach(element => {
    const zone = element.dataset.dispatchZone;
    const now = new Date();
    const perthDate = new Intl.DateTimeFormat('en-CA', {timeZone: 'Australia/Perth', year:'numeric', month:'2-digit', day:'2-digit'}).format(now);
    const cutoff = new Date(perthDate + 'T05:00:00Z');
    const time = new Intl.DateTimeFormat('en-GB', {timeZone: zone, hour:'numeric', minute:'2-digit', hour12:true}).format(cutoff);
    const names = {'America/New_York':'Eastern Time', 'Europe/London':'UK time', 'Europe/Dublin':'Irish time', 'Europe/Lisbon':'mainland Portugal time', 'Europe/Helsinki':'Finnish time', 'Europe/Athens':'Greek time', 'Europe/Paris':'Central European time'};
    element.querySelector('[data-dispatch-cutoff]').textContent = time + ' ' + names[zone];
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
  document.addEventListener('shopify:section:load', update);
})();
  } catch(e) { console.error(e); }
})();

})();
